"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "form-container" };
var _hoisted_2 = { class: "form-title" };
var _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h4", null, "古诗学习", -1);
var _hoisted_4 = { class: "button-box" };
var _hoisted_5 = { class: "table-box" };
var vue_3 = require("vue");
var ancient_poetry_1 = require("@/apis/ancient-poetry");
var vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'IndexView',
    setup: function (__props) {
        /* eslint-disable */
        var route = (0, vue_router_1.useRoute)();
        var columns = (0, vue_3.reactive)([
            {
                title: '标题',
                dataIndex: 'title',
                align: "center",
                isLink: true,
            },
            {
                title: '作者',
                dataIndex: 'author',
                align: "center",
                width: 100,
            },
            {
                title: '类型',
                dataIndex: 'category',
                align: "center",
                width: 100,
            },
            {
                title: '朝代',
                dataIndex: 'dynasty',
                align: "center",
                width: 100,
            },
            {
                title: '内容',
                dataIndex: 'content',
                align: "center",
                overflow: true,
            },
            {
                title: '译文',
                dataIndex: 'translate',
                align: "center",
                overflow: true
            },
        ]);
        var categoryOption = (0, vue_3.reactive)([
            '唐诗三百', '古诗三百', '宋词三百', '小学古诗', '初中古诗', '高中古诗', '宋词精选', '古诗十九', '诗经', '楚辞', '乐府', '写景', '咏物', '春天', '夏天', '秋天', '冬天',
            '写雨', '写雪', '写风', '写花', '梅花', '荷花', '菊花', '柳树', '月亮', '山水', '写山', '写水', '长江', '黄河', '儿童', '写鸟', '写马',
            '田园', '边塞', '地名', '节日', '春节', '元宵', '寒食', '清明', '端午', '七夕', '中秋', '重阳', '怀古', '抒情', '爱国', '离别', '送别', '思乡',
            '思念', '爱情', '励志', '哲理', '闺怨', '悼亡', '写人', '老师', '母亲', '友情', '战争', '读书', '惜时', '忧民', '婉约', '豪放', '民谣'
        ]);
        var dynastyOption = (0, vue_3.reactive)([
            '先秦', '两汉', '魏晋', '南北朝', '隋代', '唐代', '五代', '宋代', '元代', '明代', '清代', '近现代', '金朝'
        ]);
        var list = (0, vue_3.ref)([]);
        var total = (0, vue_3.ref)(0);
        var isShowMoreSearch = (0, vue_3.ref)(false);
        var query = route.query;
        var params = (0, vue_3.ref)({
            page: 1,
            limit: 10,
            category: '',
            title: '',
            dynasty: "",
            author: "",
            content: "",
        });
        if (query.limit) {
            params.value.category = query.category;
            params.value.title = query.title;
            params.value.dynasty = query.dynasty;
            params.value.author = query.author;
            params.value.content = query.content;
            params.value.limit = parseInt(query.limit);
            params.value.page = parseInt(query.page);
        }
        var fetchTableData = function () {
            ancient_poetry_1.ancientPoetryApi.getAncientPoetryList(params.value).then(function (res) {
                list.value = res.data.result;
                total.value = res.data.total;
            });
        };
        fetchTableData();
        var handleSearch = function () {
            params.value.page = 1;
            fetchTableData();
        };
        var handleSizeChange = function (val) {
            params.value.limit = val;
            params.value.page = 1;
            fetchTableData();
        };
        var handleCurrentChange = function (val) {
            params.value.page = val;
            fetchTableData();
        };
        var reSearch = function () {
            params.value = {
                page: 1,
                limit: 10,
                category: '',
                title: '',
                dynasty: "",
                author: "",
                content: "",
            };
            fetchTableData();
        };
        var router = (0, vue_router_1.useRouter)();
        var linkFun = function (value) {
            router.push({ path: "/ancient/poetry/detail", query: __assign({ id: value.id }, params.value) });
        };
        return function (_ctx, _cache) {
            var _component_el_button = (0, vue_2.resolveComponent)("el-button");
            var _component_el_input = (0, vue_2.resolveComponent)("el-input");
            var _component_el_form_item = (0, vue_2.resolveComponent)("el-form-item");
            var _component_el_option = (0, vue_2.resolveComponent)("el-option");
            var _component_el_select = (0, vue_2.resolveComponent)("el-select");
            var _component_el_form = (0, vue_2.resolveComponent)("el-form");
            var _component_table_unit = (0, vue_2.resolveComponent)("table-unit");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        _hoisted_3,
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                onClick: handleSearch,
                                icon: "Search"
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)("查询")
                                ]; }),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_button, {
                                type: "primary",
                                onClick: reSearch,
                                plain: "",
                                icon: "RefreshLeft"
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)("重置")
                                ]; }),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_button, {
                                onClick: _cache[0] || (_cache[0] = function ($event) { return ((0, vue_2.isRef)(isShowMoreSearch) //@ts-ignore
                                    ? isShowMoreSearch.value = !(0, vue_2.unref)(isShowMoreSearch) : isShowMoreSearch = !(0, vue_2.unref)(isShowMoreSearch)); }),
                                plain: "",
                                icon: (0, vue_2.unref)(isShowMoreSearch) ? 'ArrowUp' : 'ArrowDown'
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(isShowMoreSearch) ? '收起' : '展开'), 1)
                                ]; }),
                                _: 1
                            }, 8, ["icon"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", {
                        class: "form-params",
                        style: (0, vue_2.normalizeStyle)((0, vue_2.unref)(isShowMoreSearch) ? 'height:100px' : 'height:45px')
                    }, [
                        (0, vue_2.createVNode)(_component_el_form, {
                            inline: true,
                            class: "demo-form-inline",
                            "label-width": "90px",
                            model: (0, vue_2.unref)(params)
                        }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "古诗标题:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            clearable: "",
                                            onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                            modelValue: (0, vue_2.unref)(params).title,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return (((0, vue_2.unref)(params).title) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "古诗作者:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            clearable: "",
                                            onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                            modelValue: (0, vue_2.unref)(params).author,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return (((0, vue_2.unref)(params).author) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "古诗内容:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            placeholder: "请输入内容关键字",
                                            clearable: "",
                                            onKeydown: (0, vue_2.withKeys)(handleSearch, ["enter"]),
                                            modelValue: (0, vue_2.unref)(params).content,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return (((0, vue_2.unref)(params).content) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "古诗类型:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_select, {
                                            clearable: "",
                                            modelValue: (0, vue_2.unref)(params).category,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return (((0, vue_2.unref)(params).category) = $event); })
                                        }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(categoryOption, function (item, index) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_option, {
                                                        label: item,
                                                        value: item,
                                                        key: index + 'category'
                                                    }, null, 8, ["label", "value"]));
                                                }), 128))
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "作者朝代:" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_select, {
                                            clearable: "",
                                            modelValue: (0, vue_2.unref)(params).dynasty,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return (((0, vue_2.unref)(params).dynasty) = $event); })
                                        }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(dynastyOption, function (item, index) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_option, {
                                                        label: item,
                                                        value: item,
                                                        key: index + 'dynasty'
                                                    }, null, 8, ["label", "value"]));
                                                }), 128))
                                            ]; }),
                                            _: 1
                                        }, 8, ["modelValue"])
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }, 8, ["model"])
                    ], 4)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                    (0, vue_2.createVNode)(_component_table_unit, {
                        list: (0, vue_2.unref)(list),
                        onLinkFun: linkFun,
                        columns: columns,
                        onHandleCurrentChange: handleCurrentChange,
                        onHandleSizeChange: handleSizeChange,
                        total: (0, vue_2.unref)(total),
                        currentPage: (0, vue_2.unref)(params).page
                    }, null, 8, ["list", "columns", "total", "currentPage"])
                ])
            ]));
        };
    }
});
